import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Nda.title',
    defaultMessage: 'Let’s make sure we are on the same page',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Nda.subtitle',
    defaultMessage: 'We value transparency and want to make sure we work closely as a team. For that, we have a mutual beneficial NDA that we need your signature on. The NDA also covers how we collect information and how we store and use it. Please review it and sign below.',
  },
  error: {
    id: 'containers.SupplierProfile.components.Nda.error',
    defaultMessage: 'We could not create an NDA for you to sign. Please contact support@voicearchive.com.',
  },
  loading: {
    id: 'containers.SupplierProfile.components.Nda.loading',
    defaultMessage: 'Hold on a second. We\'re preparing a customized NDA for you',
  },
  validationFailed: {
    id: 'containers.SupplierProfile.components.Nda.validationFailed',
    defaultMessage: 'You have not yet signed the NDA. We ask you to please sign it to continue.',
  },
})
